import * as actionTypes from '../constants/StoreConstants';
import { Enums } from './../constants/types';

const initialState = {
   genders: null,
};

const enumsReducer = (state = initialState, action: Enums) => {
   switch (action.type) {
      case actionTypes.GET_GENDER_ENUM_SUCCESS:
         return {
            ...state,
            genders: action.payload,
         };
      default:
         return state;
   }
};

export default enumsReducer;
